import React, { useState } from 'react';
import styled from 'styled-components';

// TODO more specific parameter types
interface Props {
	handlerFromParent: (data: any, voice: any) => void;
	currentData: any;
	currentVoice: any;
	voices: any;
	datas: any;
	dataString: any;
	dataNumber: any;
	prices: any;
}

const PriceTable = styled.table`
	max-width: 22rem;
	max-height: 12rem;
	margin: auto;
	font-size: 0.8em;
	padding: 1px;
`;

const Datahead = styled.th`
	background-color: white;
	border-top: 2px solid white;
	font-size: 1rem;
	line-height: 95%;
	padding: 0;
	font-weight: 400;
`;

const Voicehead = styled.th<any>`
	font-size: 0.9rem;
	font-weight: 400;
`;

const Thead = styled.th`
	background-color: white;
	color: #f31;
	text-align: center;
	border: 2px solid #fee;
	border-bottom: 1px solid red;
	font-size: 1.15em;
	&:hover {
		background-color: #fee;
	}

	&.active {
		background-color: #fee;
		color: red;
	}

	input[type='radio'] {
		display: none;
	}

	input[type='radio'] + label {
		margin: 0;
	}

	input[type='radio'] + label span {
		background-color: white;
		border: 1px solid red;
		box-shadow: 0 0 0 2px $shadow;
		display: inline-block;
		width: 16px;
		height: 16px;
		vertical-align: middle;
		cursor: pointer;
		border-radius: 50%;
	}

	input[type='radio']:checked + label span div {
		background-color: red;
		display: inline-block;
		width: 8px;
		height: 8px;
		//vertical-align: middle;
		cursor: pointer;
		border-radius: 50%;
		margin-bottom: 10px;
	}
`;

const Thead2 = styled.td`
	background-color: white;
	color: #f31;
	width: 100px;
	text-align: center;
	border: 2px solid #fee;
	border-right: 1px solid red;
	font-size: 1.15em;
	&:hover {
		background-color: #fee;
	}

	&.active {
		background-color: #fee;
		color: red;
		width: 10px;
		height: 10px;
	}

	input[type='radio'] {
		display: none;
	}

	input[type='radio'] + label {
		margin: 0;
	}

	input[type='radio'] + label span {
		background-color: white;
		border: 1px solid red;
		box-shadow: 0 0 0 2px $shadow;
		display: inline-block;
		width: 16px;
		height: 16px;
		vertical-align: middle;
		cursor: pointer;
		border-radius: 50%;
	}

	input[type='radio']:checked + label span div {
		background-color: red;
		display: inline-block;
		width: 8px;
		height: 8px;
		//vertical-align: middle;
		cursor: pointer;
		border-radius: 50%;
		margin-bottom: 10px;
	}
`;

const Tcell = styled.td`
	background-color: white;
	border-right: solid 1px #fee;
	border-bottom: solid 1px #fee;
	text-align: center;
	padding-top: 0.4em;
	height: 4.8em;
	font-size: 1.05em;
	width: 1.2em;
	p {
		margin: 0;
	}

	&:hover {
		background-color: #fee;
	}

	&.active {
		background-color: red;
		color: white;
		font-weight: bold;
		z-index: 100;
		position: relative;
		@media (min-width: 362px) {
			font-size: 0.7rem;

			span {
				font-size: 1.2rem;
				padding-top: 0.8rem;
				background-color: red;
				position: relative;
				width: 3.6rem;
				height: 4.5rem;
				bottom: -0.2rem;
				left: -0.2rem;
				z-index: 100;
				p {
					font-size: 0.7rem;
				}
			}
		}
	}

	&.current {
		background-color: grey;
		color: black;
	}
`;

export const Matrix: React.FC<Props> = (props: Props) => {
	const [selectedColumn, setSelectedColumn] = useState(props.voices.indexOf(props.currentVoice));
	const [selectedRow, setSelectedRow] = useState((props.dataNumber as any)[props.currentData] as number);

	const handleDataClick = (data: number) => {
		setSelectedRow(data);
		handleClick(data, selectedColumn);
	};

	const handleVoiceClick = (voice: number) => {
		setSelectedColumn(props.voices.indexOf(voice));
		handleClick(selectedRow, props.voices.indexOf(voice));
	};

	const handleClick = (data: number, voice: number) => {
		setSelectedRow(data);
		setSelectedColumn(voice);
		props.handlerFromParent(data, voice);
	};

	const currentData = props.currentData;
	const currentVoice = props.currentVoice;
	// in practice radio button onChange handlers are redudant as Thead already listens click events (added onChange to avoid warning in Chrome dev tools)
	return (
		<div>
			<PriceTable>
				<tbody>
					<tr>
						<th />
						<Voicehead colSpan="5">Puheminuutteja tai viestejä per liittymä</Voicehead>
					</tr>
					<tr>
						<Datahead>
							Dataa <br /> per <br />
							liittymä
						</Datahead>
						{props.voices.map((voice: any) => {
							const headClass = selectedColumn === props.voices.indexOf(voice) ? 'active' : '';
							const checkedBoolean = selectedColumn === props.voices.indexOf(voice);
							return (
								<Thead className={headClass} key={Math.random().toString(36).substring(7)} onClick={() => handleVoiceClick(voice)}>
									{voice}
									<br />
									<input type="radio" name="voice" value="design" id={voice} checked={checkedBoolean} onChange={() => handleVoiceClick(voice)} />
									<label className="choice" htmlFor={voice}>
										<span>
											<div />
										</span>
									</label>
									<br />
								</Thead>
							);
						})}
					</tr>
					{props.datas.map((data: number, i: number) => (
						<tr key={i}>
							<Thead2 className={selectedRow === data ? 'active' : ''} key={Math.random().toString(36).substring(7)} onClick={() => handleDataClick(data)}>
								{(props.dataString as any)[data]}
								<br />
								<input type="radio" name="data" value="design" id={String(data)} checked={selectedRow === data} onChange={() => handleDataClick(data)} />
								<label className="choice" htmlFor={String(data)}>
									<span>
										<div />
									</span>
								</label>{' '}
								<br />
							</Thead2>
							{props.prices.map((price: any, voice: any) => {
								let className;
								if ((props.dataNumber as any)[currentData] === data && currentVoice === props.voices[voice]) {
									className = 'current';
								} else if (selectedRow === data && selectedColumn === voice) {
									className = 'active';
								} else {
									className = '';
								}

								return (
									<Tcell className={className} key={Math.random().toString(36).substring(7)} onClick={() => handleClick(data, voice)}>
										<span>
											{price[data]} <p>€/kk</p>
										</span>
									</Tcell>
								);
							})}
						</tr>
					))}
				</tbody>
			</PriceTable>
		</div>
	);
};
